/**
 * @Action:新旧版路由映射
 * @Author: Maple
 * @UpDate: 2025/11/12
 */

// 体验新版
export const mapOldToNew = {
  // 电站概览
  '/station': '/overview/plantStation',
  // 设备概览
  '/station/device': '/overview/device',
}

// 返回旧版
export const mapNewToOld = {
  // 电站概览
  '/overview/plantStation': '/station',
  // 设备概览
  '/overview/device': '/station/device',
}
